import { render } from "./SearchTrivia.vue?vue&type=template&id=56017192&scoped=true"
import script from "./SearchTrivia.vue?vue&type=script&lang=js"
export * from "./SearchTrivia.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=56017192&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56017192"]])

export default __exports__